import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getPreClaimsDocumentTypesAPI = () => {
  return axiosInstance.request({
    url: `${API.PRECLAIM}/GetDocumentType`,
    method: 'get',
  });
};

export type PreClaimsDocumentTypesResponse = {
  documentType: number; // 1
  description: string;
}[];

export const fetchPreClaimsDocumentTypes = async (): Promise<PreClaimsDocumentTypesResponse> => {
  const response: AxiosResponse<PreClaimsDocumentTypesResponse> = await getPreClaimsDocumentTypesAPI();
  return response.data;
};
